class ContentMinHeight {
  constructor() {
    this.init = this.init.bind(this);
    this.updateMinHeight = this.updateMinHeight.bind(this);
    this.init();
  }

  init() {
    window.addEventListener('load', () => {
      this.updateMinHeight();
    });

    window.addEventListener('resize', () => {
      this.updateMinHeight();
    });

    window.addEventListener('orientationchange', () => {
      this.updateMinHeight();
    });
  }

  updateMinHeight() {
    const documentHeight = window.innerHeight;
    const bodyHeight = document.body.scrollHeight;

    if (bodyHeight < documentHeight) {
      let stageHeight = 0;
      const stage = document.querySelector('section.stage-content');
      const mainContent = document.querySelector('main.main-content');
      const footer = document.querySelector('footer.footer');

      if (stage) {
        stageHeight = stage.offsetHeight;
      }

      if (mainContent && footer) {
        const mainContentMinHeight = documentHeight - (stageHeight + footer.offsetHeight);
        mainContent.style.minHeight = mainContentMinHeight + 'px';
      }
    }
  }
}

export default new ContentMinHeight();
